import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

axios.defaults.baseURL = 'https://69d0ebf090cd06523d5da5a9.mockapi.io/';

export const fetchBooks = createAsyncThunk(
  'books/fetchBooks',
  async (_, { rejectWithValue }) => {
    try {
      const books = await axios.get('/books');
      return books.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
